"use strict";
// --------------------------------------------------------------------------------------------------------------------
// <copyright file="MessageHeader.ts" company="Microsoft">
//   Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// <summary>
//   TypeScript implementation of the HxMessageHeader object
//   THIS FILE IS GENERATED BY A TOOL -- OBJECTGEN, DO NOT EDIT BY HAND
// </summary>
// --------------------------------------------------------------------------------------------------------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HxMessageHeader = void 0;
var HxObject_1 = __importDefault(require("./HxObject"));
var HxObjectID_1 = __importDefault(require("./HxObjectID"));
var HxObjectType_1 = __importDefault(require("./HxObjectType"));
var HxDisplayPerson_1 = require("./HxDisplayPerson");
var HxObjectIdStringPair_1 = require("./HxObjectIdStringPair");
var HxStringPair_1 = require("./HxStringPair");
var HxMessageHeader = /** @class */ (function (_super) {
    __extends(HxMessageHeader, _super);
    function HxMessageHeader(objectId, storageSequenceNumber, obj, activeSet) {
        var _this = _super.call(this, objectId, HxObjectType_1.default.HxMessageHeader, storageSequenceNumber, activeSet) || this;
        _this.update(obj);
        return _this;
    }
    HxMessageHeader.prototype.update = function (obj) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], v = _d[1];
                switch (key) {
                    case '1':
                        this.objectId = new HxObjectID_1.default(v);
                        break;
                    case '2':
                        this.parentId = new HxObjectID_1.default(v);
                        break;
                    case '51E':
                        this.accountId = new HxObjectID_1.default(v);
                        break;
                    case '7E3':
                        this.actualSenderDisplayName = v;
                        break;
                    case '7E4':
                        this.actualSenderEmailAddress = v;
                        break;
                    case '13AD':
                        this.actualSenderEmailAddressType = v;
                        break;
                    case '7ED':
                        this.actualSenderIsMe = v;
                        break;
                    case 'D84':
                        this.bodySection_Charset = v;
                        break;
                    case 'D85':
                        this.bodySection_Encoding = v;
                        break;
                    case 'D86':
                        this.bodySection_FullPath = Buffer.from(v, 'base64');
                        break;
                    case 'E7E':
                        this.bodySection_Size = v;
                        break;
                    case 'D87':
                        this.bodySection_Type = v;
                        break;
                    case '783':
                        this.calendarSharingError = v;
                        break;
                    case '1226':
                        this.canCreateAssociated = v;
                        break;
                    case '1227':
                        this.canDelete = v;
                        break;
                    case '1228':
                        this.canModify = v;
                        break;
                    case 'D90':
                        var categoriesValues = v;
                        this.categories = new Array(categoriesValues.length);
                        for (var i = 0; i < categoriesValues.length; i++) {
                            this.categories[i] = categoriesValues[i];
                        }
                        break;
                    case '9C8':
                        this.classicGroupedConversationId = new HxObjectID_1.default(v);
                        break;
                    case '9D4':
                        this.classicGroupedConversationServerId = v;
                        break;
                    case '5C8':
                        this.classicMessageConversationId = new HxObjectID_1.default(v);
                        break;
                    case '668':
                        this.classification = v;
                        break;
                    case 'F92':
                        this.deferredSendTime = new Date(v);
                        break;
                    case '53B':
                        this.deviceId = v;
                        break;
                    case 'DCD':
                        this.displayTime = new Date(v);
                        break;
                    case 'DF1':
                        this.fetchedByServerId = v;
                        break;
                    case 'CE1':
                        this.groupId = new HxObjectID_1.default(v);
                        break;
                    case '517':
                        this.hasFileAttachment = v;
                        break;
                    case '135C':
                        this.hasToDoTasks = v;
                        break;
                    case '5C9':
                        this.headerChangeKey = v;
                        break;
                    case '514':
                        this.importance = v;
                        break;
                    case '12E9':
                        this.inDeletedItems = v;
                        break;
                    case '1515':
                        this.inReplyTo = v;
                        break;
                    case 'C74':
                        this.internetMessageId = v;
                        break;
                    case 'CA8':
                        this.isBodyUpToDate = v;
                        break;
                    case '75E':
                        this.isCalendarSharing = v;
                        break;
                    case 'F2F':
                        this.isDeliveryReceiptRequested = v;
                        break;
                    case '532':
                        this.isDraft = v;
                        break;
                    case '5D5':
                        this.isEML = v;
                        break;
                    case '1422':
                        this.isExternalSender = v;
                        break;
                    case '510':
                        this.isFlagged = v;
                        break;
                    case '519':
                        this.isForwardedMail = v;
                        break;
                    case '60D':
                        this.isMissingData = v;
                        break;
                    case 'D17':
                        this.isOnlyToMe = v;
                        break;
                    case '1293':
                        this.isPinned = v;
                        break;
                    case '512':
                        this.isRead = v;
                        break;
                    case '12CE':
                        this.isReadReceiptPending = v;
                        break;
                    case 'F30':
                        this.isReadReceiptRequested = v;
                        break;
                    case '518':
                        this.isRepliedMail = v;
                        break;
                    case '513':
                        this.isRestricted = v;
                        break;
                    case '51A':
                        this.isSigned = v;
                        break;
                    case '51B':
                        this.isSmimeOpaqueOrEncrypted = v;
                        break;
                    case '15DE':
                        this.isToMe = v;
                        break;
                    case '14DF':
                        this.itemClass = v;
                        break;
                    case '127B':
                        this.lastModifiedTime = new Date(v);
                        break;
                    case 'B5A':
                        this.meetingHeaderId = new HxObjectID_1.default(v);
                        break;
                    case 'B5B':
                        this.meetingHeaderType = v;
                        break;
                    case '769':
                        this.mentionedMe = v;
                        break;
                    case '536':
                        this.messageDataId = new HxObjectID_1.default(v);
                        break;
                    case '50A':
                        this.normalizedSubject = v;
                        break;
                    case '817':
                        this.originMessageServerId = v;
                        break;
                    case 'AE1':
                        this.ownedBySearch = v;
                        break;
                    case '12EA':
                        this.ownedBySearchOrInDeleted = v;
                        break;
                    case '12EB':
                        this.ownedBySearchOrInDeletedOrJunk = v;
                        break;
                    case '12EC':
                        this.ownedBySearchOrInDeletedOrJunkOrOutbox = v;
                        break;
                    case '7A6':
                        var pinnedContactViewsValues = v;
                        this.pinnedContactViews = new Array(pinnedContactViewsValues.length);
                        for (var i = 0; i < pinnedContactViewsValues.length; i++) {
                            this.pinnedContactViews[i] = pinnedContactViewsValues[i];
                        }
                        break;
                    case 'F86':
                        this.possiblyHasInlineAttachment = v;
                        break;
                    case '50F':
                        this.preview = v;
                        break;
                    case '58E':
                        this.recipientCount = v;
                        break;
                    case '58D':
                        var recipientDisplayNamesValues = v;
                        this.recipientDisplayNames = new Array(recipientDisplayNamesValues.length);
                        for (var i = 0; i < recipientDisplayNamesValues.length; i++) {
                            this.recipientDisplayNames[i] = HxDisplayPerson_1.deserializeHxDisplayPerson(recipientDisplayNamesValues[i]);
                        }
                        break;
                    case 'C0B':
                        this.saveDraftState = v;
                        break;
                    case 'E1F':
                        this.scheduledReturnTime = new Date(v);
                        break;
                    case 'AB1':
                        this.scheduleStatus = v;
                        break;
                    case 'F73':
                        this.searchDataId = new HxObjectID_1.default(v);
                        break;
                    case 'F75':
                        var searchPreviewsValues = v;
                        this.searchPreviews = new Array(searchPreviewsValues.length);
                        for (var i = 0; i < searchPreviewsValues.length; i++) {
                            this.searchPreviews[i] = HxObjectIdStringPair_1.deserializeHxObjectIdStringPair(searchPreviewsValues[i]);
                        }
                        break;
                    case '6E4':
                        this.senderDisplayName = v;
                        break;
                    case '6E5':
                        this.senderEmailAddress = v;
                        break;
                    case '13AE':
                        this.senderEmailAddressType = v;
                        break;
                    case '6E6':
                        this.senderIsMe = v;
                        break;
                    case 'C0C':
                        this.sendErrorCount = v;
                        break;
                    case '533':
                        this.sendState = v;
                        break;
                    case '14E6':
                        this.sentTime = new Date(v);
                        break;
                    case '538':
                        this.serverId = v;
                        break;
                    case 'AB2':
                        this.sharingMessageActionId = new HxObjectID_1.default(v);
                        break;
                    case '14E0':
                        this.size = v;
                        break;
                    case '824':
                        this.smartReplyOriginMessageHeaderId = new HxObjectID_1.default(v);
                        break;
                    case 'DCE':
                        this.sortTime = new Date(v);
                        break;
                    case '509':
                        this.subject = v;
                        break;
                    case 'D8D':
                        this.tailoredEventType = v;
                        break;
                    case '5FC':
                        this.toastDismissed = v;
                        break;
                    case '100C':
                        var truncatedMentionsValues = v;
                        this.truncatedMentions = new Array(truncatedMentionsValues.length);
                        for (var i = 0; i < truncatedMentionsValues.length; i++) {
                            this.truncatedMentions[i] = HxStringPair_1.deserializeHxStringPair(truncatedMentionsValues[i]);
                        }
                        break;
                    case '51F':
                        this.viewId = new HxObjectID_1.default(v);
                        break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    HxMessageHeader.prototype.getAccount = function (sessionId) {
        return this.activeSet.getObject(this.accountId, sessionId).then(function (result) { return result; });
    };
    HxMessageHeader.prototype.getClassicGroupedConversation = function (sessionId) {
        return this.activeSet.getObject(this.classicGroupedConversationId, sessionId).then(function (result) { return result; });
    };
    HxMessageHeader.prototype.getClassicMessageConversation = function (sessionId) {
        return this.activeSet.getObject(this.classicMessageConversationId, sessionId).then(function (result) { return result; });
    };
    HxMessageHeader.prototype.getGroup = function (sessionId) {
        return this.activeSet.getObject(this.groupId, sessionId).then(function (result) { return result; });
    };
    HxMessageHeader.prototype.getMeetingHeader = function (sessionId) {
        return this.activeSet.getObject(this.meetingHeaderId, sessionId).then(function (result) { return result; });
    };
    HxMessageHeader.prototype.getMessageData = function (sessionId) {
        return this.activeSet.getObject(this.messageDataId, sessionId).then(function (result) { return result; });
    };
    HxMessageHeader.prototype.getSearchData = function (sessionId) {
        return this.activeSet.getCollection(this.searchDataId, sessionId);
    };
    HxMessageHeader.prototype.getSharingMessageAction = function (sessionId) {
        return this.activeSet.getObject(this.sharingMessageActionId, sessionId).then(function (result) { return result; });
    };
    HxMessageHeader.prototype.getSmartReplyOriginMessageHeader = function (sessionId) {
        return this.activeSet.getObject(this.smartReplyOriginMessageHeaderId, sessionId).then(function (result) { return result; });
    };
    HxMessageHeader.prototype.getView = function (sessionId) {
        return this.activeSet.getObject(this.viewId, sessionId).then(function (result) { return result; });
    };
    return HxMessageHeader;
}(HxObject_1.default));
exports.HxMessageHeader = HxMessageHeader;
exports.default = HxMessageHeader;
